module.exports = __webpack_public_path__ + "img/logo2_m.d17c0979.png";